<template>
  <div
    role="group"
    :class="mergedClasses"
    v-bind="passthroughAttrs"
  >
    <label
      v-if="label"
      :for="labelFor"
      class="d-block"
    >
      {{ label }}
    </label>
    <slot />
    <div
      v-if="showInvalidFeedback"
      class="invalid-feedback d-block"
    >
      {{ invalidFeedback }}
    </div>
    <small
      v-if="description"
      class="form-text text-muted"
    >
      {{ description }}
    </small>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HdFormGroup',

  inheritAttrs: false,

  props: {
    label: {
      type: String,
      default: null
    },
    labelFor: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    invalidFeedback: {
      type: String,
      default: null
    },
    state: {
      type: [Boolean, String],
      default: null
    }
  },

  emits: [],

  computed: {
    groupClasses() {
      const classes = ['form-group'];

      if (this.state === true) classes.push('is-valid');
      if (this.state === false) classes.push('is-invalid');

      return classes;
    },

    mergedClasses() {
      return [this.$attrs.class, this.groupClasses].flat().filter(Boolean);
    },

    passthroughAttrs() {
      const { class: _class, ...attrs } = this.$attrs;

      return attrs;
    },

    showInvalidFeedback() {
      return this.state === false && this.invalidFeedback;
    }
  }
});
</script>
